<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @uploadFile="openUploadFile"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <AmzUploadFiles
      :visible.sync="amzUploadFilesVisible"
      :fileType="fileType"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import AmzUploadFiles from '@/views/ecom/components/amz-upload-files'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, AmzUploadFiles },
  data() {
    return { 
      usePage: true, 
      amzUploadFilesVisible: false,  

      listFileType: ['ALLLISTING', 'ACTIVELISTING'],
      fileType: 'ALLLISTING',
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFileListApi({
          listFileType: this.listFileType,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openUploadFile(fileType) {
      this.amzUploadFilesVisible = true
      this.fileType = fileType
    }
  },
}
</script>
